// initialed state
export const initialState = () => ({
	data: {},
	sharedData: {},
	appsWorkspaces: [],
	sharedDataLoading: false,
	sharedWorkflows: [],
	waitingForSampleDataWorkflowIds: [],
	updatingWorkflowIds: [],
});

const state = initialState();

export default state;
